import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Carrega o script do MaxHelp
const loadScript = () => {
  const script = document.createElement('script');
  script.src = environment.maxHelpScriptUrl;
  script.type = 'module';
  script.async = true;

  script.onerror = (error) => {
    console.warn('Script não essencial falhou:', error);
  };

  document.body.appendChild(script);
};

loadScript();
